// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar-module--sidebar--X4z2p","sidebar__inner":"Sidebar-module--sidebar__inner--Jdc5s","sidebar__inner-subscribe":"Sidebar-module--sidebar__inner-subscribe--1Keft"};